import React, { useContext } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import Modal from '../../modal/Modal';
import ChangePassword from '../profile/ChangePassword';
import PgeButton from '../../pge-button/_PgeButton';
import PGEButton from '../../buttons';
import useInvoicePaymentAuth from '../../../hooks/invoice-payment-portal/useInvoicePaymentAuth';
import {
  Card,
  CardContent,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import colors from '../../../themes/main-colors';
import theme from '../../../themes/theme';
import PasswordTextField from '../../password-text-field';
import PasswordIndicatorList from '../../password-indicator-list';
import useContentMgmt from '../../../hooks/useContentMgmt';
import microcopyGroupIds from '../../pge-plus-common/microcopyGroupIds';
import useFormState from '../../../hooks/useFormState';

import validationRules from '../../change-password/ChangePassword.rules';
import { isValidPassword } from '../../../util/form-validation';
import useWrapWithLoader from '../../../hooks/useWrapWithLoading';
import { NotificationsContext } from '../../../providers/NotificationsProvider';

const PREFIX = 'InvoicePaymentLoginForm';

type Props = {
  open: boolean;
  email: string;
  oldPassword: string;
  setIsChangePassword:(isChangePassword:boolean)=>void;
};

const useStyles = makeStyles(() =>
  createStyles({
    actionArea: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    submitButton: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  }),
);

export default function InvoiceChangePasswordModal({
  open,
  email,
  oldPassword,
  setIsChangePassword
}: Props) {
  const classes = useStyles();

  const {
    changePassword,
    handleRedirect
  } = useInvoicePaymentAuth();
  const { content } = useContentMgmt(
    microcopyGroupIds.INVOICE_PAYMENT_CHANGE_PASSWORD,
  );
  const { wrapWithLoader } = useWrapWithLoader();
  const form = useFormState({
    password: '',
  });
  const onFailure = (): void => {
    form.setError(
      'password',
      content.get('GENERIC_ERROR_NOTIFICATION_MESSAGE'),
    );
  };
  const onClose = ()=>{
    setIsChangePassword(false);
  }
  const handleSubmit = wrapWithLoader(
    form.submit(async () => {
      try {
        const result = await changePassword(
          email,
          oldPassword,
          form.values.password,
        );
        if (result.status === 'SUCCESS') {
          handleRedirect();
          return;
        } else {
          onFailure();
          return;
        }
      } catch (error) {
        onFailure();
        return;
      }
    }),
  );

  return (
    <Modal
      open={open}
      showCloseIcon={true}
      title={''}
      onClose={onClose}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      style={{
      width: 700,
      maxWidth: '90vw',
      display: 'flex',
      alignItems: 'center',
      justifySelf: 'center',
      }}
    >
      <form noValidate>
        <Grid container spacing={2} css={{ marginTop: theme.spacing(2) }}>
          <Grid item>
            <Typography variant={'h1'}>
              {content.get('CHANGE_PASSWORD_BUTTON')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant={'h2'}>
                      {content.get('ENTER_NEW_PASSWORD')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <PasswordTextField
                      name="password"
                      style={{ width: '100%' }}
                      inputProps={{ minLength: 8, maxLength: 16 }}
                      {...form.props('password')}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <PasswordIndicatorList password={form.values.password} />
                  </Grid>
                  <Grid item xs={12} className={classes.actionArea}>
                    <PGEButton
                      className={classes.submitButton}
                      type={'button'}
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      disabled={!isValidPassword(form.values.password)}
                    >
                      {content.get('CHANGE_PASSWORD_BUTTON')}
                    </PGEButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>
      {/* <PGEButton
                    type={'submit'}
                    variant="contained"
                    color="primary"
                    onClick={()=>changePassword(email,oldPassword,'Password1')}
                  >
                    {'ChangePassword'}
                  </PGEButton> */}
    </Modal>
  );
}
